import r from"styled-components";import{theme as o}from"../../../../../theme.js";const a=r.div`
  padding: ${o.spacing*4}px ${o.spacing*2}px;
  border-radius: ${o.radius}px;
  display: grid;
  grid-template-columns: 24px 1fr max-content;
  grid-gap: ${o.spacing*2}px;
  background-color: ${o.colors.gray[100]};
  align-items: center;
  > svg {
    width: 24px;
    height: 24px;
    > g,
    path {
      fill: ${o.colors.primary[500]};
    }
  }
  > input {
    background-color: unset;
    color: ${o.colors.gray[900]};
    border: unset;
    padding: 0;
    font-size: 16px;
    outline: none;
    &::placeholder {
      color: ${o.colors.gray[400]};
    }
  }
`,i=r.div`
  > div {
    flex-direction: row;
    gap: ${o.spacing*4}px;
  }
`,n=r.div`
  display: grid;
  grid-template-columns: 40px max-content 40px;
  grid-column-gap: ${o.spacing}px;
  align-items: center;
  background-color: ${o.colors.gray[50]};
  border-radius: ${o.radius}px;
  padding: ${o.spacing}px;
  width: fit-content;
  scroll-snap-stop: always;
  scroll-snap-align: center;
  > span {
    font-size: 16px;
    color: ${o.colors.gray[700]};
    line-height: 24px;
  }
`,p=r.div`
  display: flex;
  width: 100%;
  gap: ${o.spacing*4}px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  flex-wrap: nowrap;
`;export{n as HubContainer,p as HubsSelectedContainer,a as InputContainer,i as PrivacySelectorContainer};
